module.exports = __webpack_public_path__ + "img/orange_067.2e26c392.png";